import { useEffect, useState } from 'react';
import { Container, Row, Col, Alert, Image, Spinner, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { config } from '../../config';

const ActivateMail = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [loader, setLoder] = useState(true);
    const [isActivated, setIsActivated] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        activateMail(token);
    }, [token]);

    const activateMail = async (t) => {
        try {
            const res = await activateMailApi(t);
            setLoder(false);
            setIsActivated(true);
        } catch (err) {
            setLoder(false);
            setError(err.message);
            console.log('catch error: ', err);
        }
    }

    const activateMailApi = async (t) => {
        const response = await fetch(`${config.url}/auth/activate-user-email-account/${t}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const resData = await response.json();

        if (!response.ok) {
            throw new Error(resData.message || 'Activate mail Faild');
        }
        
        return resData;
    }

    const goToLoginPage = () => {
        navigate('/login');
    }

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh', overflow: 'auto' }}>
            <Container>
                <Row className="justify-content-md-center text-center pt-4">
                    <Col sm="12" md="4">
                        <Image src="/images/floworglogo.png" style={{ width: '80%' }} />
                    </Col>
                </Row>

                <Row className="justify-content-md-center mt-5">
                    <Col sm="12" md="6">
                        {loader && (
                            <Alert variant="secondary">
                                <p style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}>Activating your account</p>
                                <p style={{ fontSize: '24px', textAlign: 'center' }}>Please wait</p>
                                <p style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}>
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </Spinner>
                                </p>
                            </Alert>
                        )}

                        {isActivated && (
                            <Alert variant="secondary">
                                <p style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}>Congratulations</p>
                                <p style={{ fontSize: '21px', textAlign: 'center' }}>
                                    Your account is activated now.
                                </p>
                                <div style={{ textAlign: 'center' }}>
                                    <Button variant="primary" onClick={goToLoginPage}>Login</Button>
                                </div>
                            </Alert>
                        )}

                        {error && (
                            <Alert variant="danger">
                                <p style={{ fontWeight: 'bold', fontSize: '30px', textAlign: 'center' }}>{error}</p>
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ActivateMail;
